import { render, staticRenderFns } from "./tablecard.vue?vue&type=template&id=155c2b60&"
import script from "./tablecard.vue?vue&type=script&lang=js&"
export * from "./tablecard.vue?vue&type=script&lang=js&"
import style0 from "./tablecard.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports